import React, { useEffect } from "react";

import ResourceFilterHeader from "./ResourceFilterHeader";
import ResourceContainer from "./ResourceContainer";

import style from "../../../styles/sass/searchresult.module.scss";
/* import styles from "../../../styles/sass/search.module.scss"; */
/* import { setHeaderSpace } from "../../../utils/CommonFunctions"; */

const SearchResult = (props) => {
  /* for set header */
  /* useEffect(() => {
    setHeaderSpace();
  }, []); */

  return (
    <>
    {/* <div className={`${styles["booking-container-outer-box"]}`}>
      <div id="setSpacer" className="setBanner">
        <div className="bannerInner"> */}
          <section className={`mc_container_fluid p-spacerT p-spacerB ${style["nw_bk_ocb_main"]}`}>
            <div className="mc_row_new">
              <div className="mc_container_inner">
                <div className="mc_row_new">
                  <div>
                    <div className={style["nw_bk_f_cb"]}>
                      <div className={style["nw_bk_i_cb"]}>
                        <ResourceFilterHeader {...props} />
                        <ResourceContainer
                          resources={props.availableResources}
                          filter={props.filter}
                          onBookNow={props.onBookNow}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        {/* </div>
      </div>
    </div> */}
    </>
  );
};

export default React.memo(SearchResult);
